module.exports = __webpack_public_path__ + "static/mairy-bold-webfont-dcd8ecc9d3954d69745449a1f308b9b2.woff2";